import { EligibilityRule } from '../../models/eligibility-rule-set'
import { MappableModel, EligibilityCredential, Organization } from '../../models'

export class CredentialListItem extends MappableModel {
  public credentials: EligibilityCredential[]
  public organization: Organization
  public rules: EligibilityRule[]
}
